<template>

  <Head title="Registrar pago" />
  <div class="container mx-auto p-8 grid grid-cols-1 md:grid-cols-3 gap-8">
    <div class="col-span-1 bg-white rounded-lg shadow-md p-6">
      <h2 class="text-lg font-bold mb-4">Registre su pago</h2>
      <pre v-if="form.method == 'Zelle'">
          Nro cta: pagos@realgestion.com
        </pre>
      <pre v-if="form.method == 'Transferencia Bs'" class="bg-gray-200 p-5 text-right">
          0122345560523 
          Rif J-317572041
          Realgestion, C.A
        </pre>
      <pre v-if="form.method == 'Pago Móvil'" class="bg-gray-200 p-5 text-right">
          04143486881
          J-317572041
          Banesco
        </pre>
      <pre class="bg-gray-200 p-5 text-right" v-if="form.method == 'Cuenta verde'">
          J-312172550
          Smiley C.A
          Banesco
        </pre>

      <div class="mb-4">
        <label for="tipo" class="block text-gray-700 text-sm font-bold mb-2">Tipo:</label>
        <select id="tipo" v-model="form.method"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
          <option value="">Seleccionar</option>
          <option v-for="method in payment_methods" :key="method.id" :value="method.name">{{ method.name }}</option>
        </select>
      </div>

      <div class="mb-4">
        <label for="referencia" class="block text-gray-700 text-sm font-bold mb-2">Referencia:</label>
        <input type="text" id="referencia" v-model="form.reference"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
      </div>

      <div class="mb-4" v-if="form.method == 'Transferencia Bs' || form.method == 'Pago Móvil'">
        <label for="monto" class="block text-gray-700 text-sm font-bold mb-2">Monto en Bs:</label>
        <money-input
          v-model="amount_alternative"
          placeholder="0,00"
        />
      </div>

      <div class="mb-4">
        <label for="monto" class="block text-gray-700 text-sm font-bold mb-2">Monto:</label>
        <money-input
          v-model="form.amount"
          :disabled="form.method == 'Transferencia Bs' || form.method == 'Pago Móvil'"
        />
      </div>

      <div class="mb-4">
        <label for="tipo" class="block text-gray-700 text-sm font-bold mb-2">Fecha:</label>
        <input v-model="form.date" type="date"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
      </div>

      <div class="mb-4">
        <label for="comprobante" class="block text-gray-700 text-sm font-bold mb-2">Comprobante:</label>
        <input type="file" id="comprobante" @change="form.receipt = $event.target.files[0]" accept="image/*,.pdf"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
        <p class="text-sm text-gray-500 mt-1">Formatos permitidos: imágenes y PDF</p>
      </div>

      <button class="bg-blue-800 hover:bg-sky-700 text-white font-bold py-2 px-4 rounded" @click="realizarPago">
        Realizar pago
      </button>
    </div>

    <div class="col-span-2 bg-white rounded-lg shadow-md p-6 overflow-x-auto">
      <h2 class="text-lg font-bold">Pedido #{{ order.number_order }}</h2>
      <h5 class="text-md mb-4">Saldo pendiente: ${{ order.total - order.balance }} (Bs. {{ ((order.total - order.balance) * change).toFixed(2) }})</h5>
      <h2 class="text-lg font-bold mb-4">PAGOS REALIZADOS</h2>
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-blue-800">
          <tr>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">#</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Metodo
            </th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Monto
            </th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
              Referencia</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
              Comprobante</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Fecha
            </th>
            <!-- <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Estatus</th> -->
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(pago, index) in pays" :key="index">
            <td class="px-6 py-4 whitespace-nowrap">{{ pago.id }}</td>
            <td class="px-6 py-4 whitespace-nowrap">{{ pago.method }}</td>
            <td class="px-6 py-4 whitespace-nowrap">{{ pago.amount }}</td>
            <td class="px-6 py-4 whitespace-nowrap">{{ pago.reference }}</td>
            <td class="px-6 py-4 whitespace-nowrap">
              <a v-if="pago.voucher" :href="`/storage/${pago.voucher}`" target="_blank" class="bg-blue-300 rounded-md p-1 text-black">Ver comprobante</a>
              <span v-else>Sin comprobante</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">{{ pago.created_at }}</td>
            <!-- <td class="px-6 py-4 whitespace-nowrap" :class="{ 'text-green-500': pago.estatus === 'Pagado', 'text-red-500': pago.estatus === 'Pendiente' }">
                {{ pago.estatus }}
              </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import WebLayout from '../../Layouts/WebLayout.vue';
import MoneyInput from '../../Components/MoneyInput.vue'

export default {
  components: {
    Head,
    MoneyInput
  },
  layout: WebLayout,
  props: {
    pays: Object,
    payment_methods: Object,
    orderId: Number,
    order: Object,
    change: Number
  },
  data() {
    return {
      amount_alternative: 0,
      form: this.$inertia.form({
        method: '',
        reference: '',
        amount: 0,
        order_id: this.orderId,
        receipt: ''
      })
    };
  },
  watch: {
    amount_alternative: function (newValue, oldValue) {
      this.form.amount = newValue / this.change
    }
  },  
  methods: {
    realizarPago() {
      let amount = this.order.total - this.order.balance;
      if (amount < this.form.amount) {
        return alert("No se puede registrar un pago mayor al monto de la orden...")
      }
      if (!this.form.receipt) {
        return alert("Por favor adjunte el comprobante de pago");
      }

      if (!this.form.method) {
        return alert("Por favor seleccione un método de pago");
      }

      if (!this.form.reference) {
        return alert("Por favor ingrese el número de referencia");
      }

      if (!this.form.amount || this.form.amount <= 0) {
        return alert("Por favor ingrese un monto válido");
      }

      if (!this.form.date) {
        return alert("Por favor seleccione una fecha");
      }

      // Create form data to handle file upload
      let formData = new FormData();
      formData.append('method', this.form.method);
      formData.append('reference', this.form.reference);
      formData.append('amount', this.form.amount);
      formData.append('order_id', this.form.order_id);
      formData.append('date', this.form.date);
      formData.append('receipt', this.form.receipt);
      this.form.post('/web/payments', {
        forceFormData: true
      });
    }
  }
};
</script>